export const ZUS_CONTRIBUTION_RATE = 0.1952;
